module.exports = __webpack_public_path__ + "media/Audio18_b.b7442340.wav";